<template lang="pug">
  .mobile-menu
    .mobile-menu__block
      button.mobile-menu__closer(type="button" aria-label="Close menu" @click="uiStore.closeMobileMenu")
        BaseIcon(name="close")
      ul.mobile-menu__list
        li.mobile-menu__item
          RouterLink(:to="$i18nRoute({ name: 'About' })") {{ $t('menu.about') }}
        li.mobile-menu__item(v-if="categories.length")
          ExpandableItem
            template(#toggle)
              h3.expandable__title
                span {{ $t('menu.products') }}
                BaseIcon.expandable__chevron(name="chevron")
            template(#expandable)
              ul.mobile-menu__list
                li.mobile-menu__item(v-for="category in categories" :key="category.id")
                  RouterLink(
                    :to="$i18nRoute({ name: 'ProductsCategory', params: { category: category.name.toLowerCase() } })"
                  ) {{ capitalize(category.name) }}
        li.mobile-menu__item
          RouterLink(:to="$i18nRoute({ name: 'News' })") {{ $t('menu.news') }}
        li.mobile-menu__item
          RouterLink(:to="$i18nRoute({ name: 'CheckCode' })") {{ $t('menu.check_code') }}
        li.mobile-menu__item
          RouterLink(:to="$i18nRoute({ name: 'Contact' })") {{ $t('menu.contact') }}

    .mobile-menu__wrapper(@click="uiStore.closeMobileMenu")
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { RouterLink, useRoute } from 'vue-router'
import ExpandableItem from '@/components/common/ExpandableItem.vue'
import BaseIcon from '@/components/common/BaseIcon.vue'
import { useCatalogStore } from '@/stores/catalog'
import { useUiStore } from '@/stores/ui'
import { capitalize } from '@/utils/formatters'

const route = useRoute()
const uiStore = useUiStore()
const { categories } = storeToRefs(useCatalogStore())

watch(() => route.fullPath, uiStore.closeMobileMenu)

onMounted(() => {
  document.body.style.overflow = 'hidden'
})

onBeforeUnmount(() => {
  document.body.style.removeProperty('overflow')
})
</script>
